// @core/api/endpoints/team/create_temporary_role_assignment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTemporaryRoleAssignmentRequest,
  TemporaryRoleAssignmentResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Create temporary role assignment
 * Creates a new temporary role assignment with the provided data. Returns the created resource.
 */
export async function CreateTemporaryRoleAssignment(
  team_id: string,
  data: CreateTemporaryRoleAssignmentRequest,
  options?: RequestOptions
): Promise<TemporaryRoleAssignmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/temporary-assignments`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<TemporaryRoleAssignmentResponse>(requestPath, data, requestOptions);
}
